import { Reveal, Overline } from "./Reveal";

const services = [
  {
    image:
      "https://images.unsplash.com/photo-1754037783933-c25ff9f68f87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxjb3p5JTIwcHN5Y2hvdGhlcmFweSUyMG9mZmljZSUyMGFybWNoYWlyJTIwd2FybSUyMG5hdHVyYWwlMjBsaWdodCUyMHBsYW50cyUyMGludGVyaW9yfGVufDB8fHx8MTc5MjUwMTE0NHww&ixlib=rb-4.1.0&q=85",
    alt: "Studio accogliente per colloqui psicologici — poltrone e luce naturale",
    title: "Colloqui psicologici individuali",
    text: "Uno spazio per affrontare momenti di difficoltà, comprendere le proprie emozioni e dare senso a ciò che si sta vivendo.",
  },
  {
    image:
      "https://images.pexels.com/photos/35360390/pexels-photo-35360390.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Pietre in equilibrio alla luce dorata — schemi e dinamiche relazionali",
    title: "Comprendere schemi e dinamiche relazionali",
    text: "Esplorare le modalità con cui entriamo in relazione, le difficoltà che si ripresentano e il legame tra esperienze passate e presente.",
  },
  {
    image:
      "https://images.unsplash.com/photo-1572544405078-45963c80d026?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxvcGVuJTIwam91cm5hbCUyMHZpbnRhZ2UlMjBkZXNkJTIwd2FybSUyMHN1bmxpZ2h0JTIwd2luZG93JTIwcGVufGVufDB8fHx8MTc5MjUwMTA0NXww&ixlib=rb-4.1.0&q=85",
    alt: "Diario aperto con penna alla luce calda di una finestra — mondo interiore",
    title: "Esplorazione del mondo interiore",
    text: "Un approfondimento dell'esperienza soggettiva attraverso sogni, immagini e simboli, quando pertinente al percorso individuale.",
  },
];

export const Servizi = () => (
  <section id="servizi" data-testid="servizi-section" className="py-24 sm:py-32 lg:py-40">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
      <Reveal>
        <Overline>Aree di intervento</Overline>
        <h2 className="font-serif tracking-tight leading-snug text-3xl sm:text-4xl lg:text-5xl text-sand max-w-3xl">
          Come posso <span className="italic text-gold">accompagnarti</span>
        </h2>
        <p className="mt-7 max-w-2xl text-base sm:text-lg text-sand-muted leading-relaxed">
          Ogni percorso inizia con un primo colloquio conoscitivo: un incontro senza impegno per
          conoscerci, comprendere la tua richiesta e valutare insieme come procedere.
        </p>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-testid="services-grid">
        {services.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.12}>
            <article
              data-testid={`service-card-${i}`}
              className="group h-full bg-ink-soft border border-gold/10 hover:border-gold/35 rounded-2xl overflow-hidden transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_70px_rgba(212,175,55,0.08)]"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.alt}
                  loading="lazy"
                  decoding="async"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.2s]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-soft/80 via-transparent to-transparent" />
              </div>
              <div className="p-7 sm:p-8">
                <h3 className="font-serif text-xl sm:text-2xl text-sand leading-snug">{s.title}</h3>
                <div className="w-10 h-px bg-gold/50 my-5 group-hover:w-16 group-hover:bg-gold transition-all duration-500" />
                <p className="text-sm sm:text-base text-sand-muted leading-relaxed">{s.text}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
